export default __webpack_public_path__ + "static/media/checkbox-bird.07b057ef.svg";